import { RespondToCalendarEventInput } from '@griply/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { respondToExternalCalendarEvent } from 'shared/services/backend-api';

import { queryKey as eventQueryKey } from './use-external-calendar-event-query';
import { queryKey as eventsQueryKey } from './use-external-calendar-events-query';

export const useRespondToExternalCalendarEventMutation = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async (payload: RespondToCalendarEventInput) =>
      respondToExternalCalendarEvent(payload),

    // onSettled rather than inside mutationFn: a rejected RSVP still needs the event
    // re-read (the provider may have partially applied it), and isPending should cover the
    // write rather than the refetch behind it.
    onSettled: async () => {
      await client.invalidateQueries({ queryKey: [eventsQueryKey] });
      await client.invalidateQueries({ queryKey: [eventQueryKey] });
    },
  });
};
